const mapStateToProps = (state) => {
    const {
        ui:{
            selectedGeoObjArray,
            dateRangeCriteria,
            rangeStartDate,
            rangeEndDate,
        }={},
        api:{
            workingTimeSheet,
        }={},
        service:{
            Api:{
                getWorkingTimeSheet
            }={}
        }={}
    } = state;
    // const selectedGeoObj = state?.ui?.selectedGeoObj;
    // const getGeoObjDashboard = state?.service?.Api?.getGeoObjDashboard;
    // const geoObjDashboard = state?.api?.geoObjDashboard;
    return { selectedGeoObjArray, getWorkingTimeSheet, workingTimeSheet, dateRangeCriteria, rangeStartDate, rangeEndDate, }
}

export default mapStateToProps;